import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "react-bootstrap";
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";

function UpdateFormElementDialog({ visible, onHide, element, formSectionId, onSuccess }) {
    const [name, setName] = useState("");
    const [htmlDescription, setHtmlDescription] = useState("");
    const [required, setRequired] = useState(true);
    const [note, setNote] = useState(false);
    const [image, setImage] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (visible) {
            setName(element?.name ?? "");
            setHtmlDescription(element?.html_description ?? "");
            setRequired(!!element?.required);
            setNote(!!element?.note);
            setImage(!!element?.image);
            setError("");
        }
    }, [visible, element]);

    const accesToken = JSON.parse(localStorage.getItem("credentials")) || [];

    const handleSubmit = async () => {
        setError("");
        if (!element?.id) {
            setError("ID element tidak tersedia.");
            return;
        }
        if (!name.trim()) {
            setError("Nama wajib diisi");
            return;
        }
        setSubmitting(true);
        try {
            const payload = {
                form_section_id: parseInt(formSectionId ?? element?.form_section_id, 10),
                name: name.trim(),
                html_description: htmlDescription,
                required: required ? 1 : 0,
                type: "select",
                note: note ? 1 : 0,
                image: 0//image ? 1 : 0,
            };

            const res = await fetch(
                `${getEndpointUrl()}/v2/form_elements/${element.id}?v=${getTimestamp()}`,
                {
                    method: "PUT",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesToken}`,
                    }),
                    body: JSON.stringify(payload),
                }
            );

            const json = await res.json();
            if (json.status === "ok" && json.results) {
                onSuccess?.(json.results);
                onHide?.();
            } else {
                setError(json.message || "Gagal memperbarui data");
            }
        } catch (err) {
            setError(err?.message || "Terjadi kesalahan jaringan");
        } finally {
            setSubmitting(false);
        }
    };

    const footer = (
        <div className="d-flex justify-content-end gap-2">
            <Button variant="outline-secondary" disabled={isSubmitting} onClick={onHide}>
                Batal
            </Button>
            <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                {isSubmitting ? "Menyimpan..." : "Simpan Perubahan"}
            </Button>
        </div>
    );

    return (
        <Dialog
            header="Ubah Form Element"
            visible={visible}
            onHide={onHide}
            style={{ width: "600px" }}
            modal
            footer={footer}
        >
            <div className="mb-3">
                <label className="form-label fw-semibold">Nama</label>
                <InputText
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-100 px-3"
                    placeholder="Nama element..."
                />
            </div>

            <div className="mb-3">
                <label className="form-label fw-semibold">Deskripsi (HTML)</label>
                <InputTextarea
                    value={htmlDescription}
                    onChange={(e) => setHtmlDescription(e.target.value)}
                    className="w-100 px-3 p-inputtextarea-sm"
                    autoResize
                    rows={4}
                    placeholder="Masukkan deskripsi HTML..."
                />
            </div>

            <div className="mb-3 d-flex align-items-center gap-2">
                <label className="form-label fw-semibold mb-0">Required</label>
                <InputSwitch checked={required} onChange={(e) => setRequired(!!e.value)} />
            </div>

            <div className="mb-3 d-flex align-items-center gap-2">
                <label className="form-label fw-semibold mb-0">Note</label>
                <InputSwitch checked={note} onChange={(e) => setNote(!!e.value)} />
            </div>

            {/* <div className="mb-3 d-flex align-items-center gap-2">
                <label className="form-label fw-semibold mb-0">Image</label>
                <InputSwitch checked={image} onChange={(e) => setImage(!!e.value)} />
            </div> */}

            {error && <div className="alert alert-danger py-2">{error}</div>}
        </Dialog>
    );
}

export default UpdateFormElementDialog;